import { render, staticRenderFns } from "./supplier-orders-list.vue?vue&type=template&id=0ed9a613&scoped=true"
import script from "./supplier-orders-list.vue?vue&type=script&lang=js"
export * from "./supplier-orders-list.vue?vue&type=script&lang=js"
import style0 from "./supplier-orders-list.vue?vue&type=style&index=0&id=0ed9a613&prod&scoped=true&lang=css"
import style1 from "./supplier-orders-list.vue?vue&type=style&index=1&id=0ed9a613&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed9a613",
  null
  
)

export default component.exports